var _path, _path2, _circle, _g, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewyearBubble24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2523 20.8571C17.4595 20.8571 21.6809 16.6358 21.6809 11.4286C21.6809 6.22132 17.4595 2 12.2523 2C7.04501 2 2.82369 6.22132 2.82369 11.4286C2.82369 12.4163 2.97558 13.3686 3.25727 14.2633C3.49663 15.0236 3.55583 15.8435 3.28345 16.5925L2.61576 18.4287C2.13545 19.7495 1.89528 20.41 2.04353 20.8403C2.17239 21.2144 2.46632 21.5083 2.84041 21.6372C3.27077 21.7854 3.93119 21.5453 5.25206 21.065L7.08801 20.3973C7.83714 20.1249 8.65716 20.1841 9.41748 20.4235C10.3122 20.7053 11.2645 20.8571 12.2523 20.8571Z",
    fill: "url(#paint0_linear_1_392)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2523 20.8571C17.4595 20.8571 21.6809 16.6358 21.6809 11.4286C21.6809 6.22132 17.4595 2 12.2523 2C7.04501 2 2.82369 6.22132 2.82369 11.4286C2.82369 12.4163 2.97558 13.3686 3.25727 14.2633C3.49663 15.0236 3.55583 15.8435 3.28345 16.5925L2.61576 18.4287C2.13545 19.7495 1.89528 20.41 2.04353 20.8403C2.17239 21.2144 2.46632 21.5083 2.84041 21.6372C3.27077 21.7854 3.93119 21.5453 5.25206 21.065L7.08801 20.3973C7.83714 20.1249 8.65716 20.1841 9.41748 20.4235C10.3122 20.7053 11.2645 20.8571 12.2523 20.8571Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_392)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3486,
    cy: 11.2404,
    r: 9.64905,
    transform: "rotate(-140 12.3486 11.2404)",
    fill: "url(#paint1_linear_1_392)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.3486,
    cy: 11.2404,
    r: 9.64905,
    transform: "rotate(-140 12.3486 11.2404)",
    fill: "url(#paint2_linear_1_392)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.23,
    cx: 13.5233,
    cy: 9.05089,
    r: 6.05838,
    transform: "rotate(-140 13.5233 9.05089)",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5621 2.33559C5.68258 1.88814 6.31742 1.88814 6.4379 2.33559L6.89607 4.03727C7.03614 4.5575 7.44251 4.96386 7.96273 5.10393L9.66441 5.5621C10.1119 5.68258 10.1119 6.31742 9.66441 6.4379L7.96273 6.89607C7.4425 7.03614 7.03614 7.44251 6.89607 7.96273L6.4379 9.66441C6.31742 10.1119 5.68257 10.1119 5.5621 9.66441L5.10393 7.96273C4.96386 7.4425 4.55749 7.03614 4.03727 6.89607L2.33559 6.4379C1.88814 6.31742 1.88814 5.68257 2.33559 5.5621L4.03727 5.10393C4.5575 4.96386 4.96386 4.55749 5.10393 4.03727L5.5621 2.33559Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78105 9.1678C2.84129 8.94407 3.15871 8.94407 3.21895 9.1678L3.44804 10.0186C3.51807 10.2787 3.72125 10.4819 3.98137 10.552L4.8322 10.781C5.05593 10.8413 5.05593 11.1587 4.8322 11.219L3.98137 11.448C3.72125 11.5181 3.51807 11.7213 3.44804 11.9814L3.21895 12.8322C3.15871 13.0559 2.84129 13.0559 2.78105 12.8322L2.55196 11.9814C2.48193 11.7213 2.27875 11.5181 2.01863 11.448L1.1678 11.219C0.944068 11.1587 0.944068 10.8413 1.1678 10.781L2.01863 10.552C2.27875 10.4819 2.48193 10.2787 2.55196 10.0186L2.78105 9.1678Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_392",
    x1: 2,
    y1: 2,
    x2: 21.6807,
    y2: 21.6809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#619DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505DE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_392",
    x1: 2.69955,
    y1: 1.59135,
    x2: 21.9976,
    y2: 20.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_392",
    x1: 2.69955,
    y1: 1.59135,
    x2: 21.9976,
    y2: 20.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewyearBubble24);
export default __webpack_public_path__ + "static/media/newyear-bubble_24.b363d136.svg";
export { ForwardRef as ReactComponent };